import React from 'react';
import { Col } from 'reactstrap';
import PropTypes from 'prop-types';
// import Skeleton from '@material-ui/lab/Skeleton';
// import './styles.scss';


/*=============================================
=            Card Toptals Conponent           =
=============================================*/
function CardTotals(props) {
  return (
    <Col xs={12} md={12} lg={12}>
      {/* <Card className="myCard2"> */}
      {/* <CardBody style= {{marginBottom:'-1em'}}> */}
      <div className="card flex-row align-items-center align-items-stretch border-0">
        <div className={props.propertiesIcon}>
          {props.image}
        </div>
        <div className={props.propertiesTitle}>
          <div className="h4 mt-0">{props.total}</div>
          <div className="">{props.title}</div>
        </div>
      </div>
      {/* </CardBody> */}
      {/* </Card> */}
    </Col>
  );
}

// Especifica los valores por defecto de props:
CardTotals.defaultProps = {
  xl: 3,
  md: 6,
  sm: 12
};

CardTotals.propTypes = {
  xl: PropTypes.number,
  md: PropTypes.number,
  sm: PropTypes.number,
  propertiesIcon: PropTypes.string,
  image: PropTypes.element,
  propertiesTitle: PropTypes.string,
  total: PropTypes.number,
  title: PropTypes.string
};

export default CardTotals;